import { PartnerCampaignCollateral } from '@core/models/partner-campaign.model';
import { CachedAttr, CACHE_TYPES } from '@yourcause/common/cache';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class PartnerCampaignState extends BaseYcState {
  @CachedAttr(CACHE_TYPES.LOCALSTORAGE, null)
  readonly currentPartnerCampaignCollateral: PartnerCampaignCollateral;
  readonly partnerCampaignCollateralIsOpen: boolean = true;
}
